<p-toast position="top-center" />

<div class="dl-page">
  <aside class="dl-brand">
    <div class="dl-brand-bg" aria-hidden="true">
      <span class="dl-mesh dl-mesh--one"></span>
      <span class="dl-mesh dl-mesh--two"></span>
      <span class="dl-mesh dl-mesh--three"></span>
      <span class="dl-noise"></span>
    </div>

    <header class="dl-brand-header">
      <span class="dl-mark">Bhade Clinic</span>
      <span class="dl-mark-dot" aria-hidden="true"></span>
    </header>

    <div class="dl-brand-main">
      <div class="dl-copy">
        <span class="dl-badge">Homeopathy · Pune</span>
        <h1 class="dl-doctor-name">Dr. Subodh Bhade</h1>
        <p class="dl-role">Consultant Homeopath</p>
        <p class="dl-lede">Gentle, individualised care for every patient who walks through our doors.</p>

        <div class="dl-pills" aria-label="Clinic highlights">
          <span><i class="pi pi-shield" aria-hidden="true"></i> Secure workspace</span>
          <span><i class="pi pi-heart" aria-hidden="true"></i> Patient-first</span>
        </div>
      </div>

      <figure class="dl-portrait">
        <img
          *ngIf="!avatarMissing"
          [src]="avatarSrc"
          alt="Dr. Subodh Bhade"
          (error)="avatarMissing = true"
        />
        <div class="dl-portrait-fallback" *ngIf="avatarMissing">
          <i class="pi pi-user-md" aria-hidden="true"></i>
        </div>
      </figure>
    </div>

    <footer class="dl-brand-footer">
      <p class="dl-quote">“Healing begins with understanding the person, not just the symptom.”</p>
      <span>© 2026 Bhade Clinic</span>
    </footer>
  </aside>

  <main class="dl-panel">
    <div class="dl-mobile-hero">
      <figure class="dl-mobile-portrait">
        <img
          *ngIf="!avatarMissing"
          [src]="avatarSrc"
          alt=""
          aria-hidden="true"
          (error)="avatarMissing = true"
        />
        <div class="dl-mobile-portrait-fallback" *ngIf="avatarMissing">
          <i class="pi pi-user-md" aria-hidden="true"></i>
        </div>
      </figure>
      <div class="dl-mobile-copy">
        <span class="dl-mobile-badge">Homeopathy · Pune</span>
        <h1 class="dl-mobile-name">Dr. Subodh Bhade</h1>
        <p class="dl-mobile-role">Consultant Homeopath</p>
      </div>
    </div>

    <div class="dl-card">
      <div class="dl-card-accent" aria-hidden="true"></div>

      <header class="dl-panel-head">
        <p class="dl-eyebrow">Staff sign in</p>
        <h2>{{ greeting }}</h2>
        <p class="dl-subtitle">Enter your clinic credentials to open the workspace.</p>
      </header>

      <form class="dl-form" (ngSubmit)="login()">
        <div class="dl-field">
          <label class="dl-label" for="staff-email">Email address</label>
          <div class="dl-input-shell">
            <i class="pi pi-envelope dl-input-icon" aria-hidden="true"></i>
            <input
              id="staff-email"
              name="email"
              type="email"
              autocomplete="username"
              placeholder="you@clinic.in"
              [(ngModel)]="loginUser.email"
              required
            />
          </div>
        </div>

        <div class="dl-field">
          <label class="dl-label" for="staff-password">Password</label>
          <div class="dl-input-shell">
            <i class="pi pi-lock dl-input-icon" aria-hidden="true"></i>
            <input
              id="staff-password"
              name="password"
              [type]="showPassword ? 'text' : 'password'"
              autocomplete="current-password"
              placeholder="Your password"
              [(ngModel)]="loginUser.password"
              required
            />
            <button
              type="button"
              class="dl-input-toggle"
              (click)="showPassword = !showPassword"
              [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
            >
              <i class="pi" [ngClass]="showPassword ? 'pi-eye-slash' : 'pi-eye'" aria-hidden="true"></i>
            </button>
          </div>
        </div>

        <div class="dl-form-row">
          <label class="dl-check">
            <input type="checkbox" name="rememberMe" [(ngModel)]="rememberMe" />
            <span>Keep me signed in</span>
          </label>
          <a class="dl-forgot" routerLink="/sso/admforgotpassword">Forgot password?</a>
        </div>

        <button type="submit" class="dl-submit" [disabled]="submitting">
          <span>{{ submitting ? 'Signing in…' : 'Sign in' }}</span>
          <i class="pi pi-arrow-right" aria-hidden="true"></i>
        </button>
      </form>

      <div class="dl-card-divider" aria-hidden="true"></div>

      <p class="dl-patient-link">
        Patient visiting us?
        <a routerLink="/register">Register here</a>
      </p>
    </div>
  </main>
</div>
